import Vue from 'vue'
import '@/utils/crossPage'
import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
import 'element-ui/lib/theme-chalk/icon.css'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // internationalization
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import '@/assets/iconfont/iconfont'

import permission from './directive/permission/index'

import * as filters from './filters' // global filters
import SvgIcon from '@/components/SvgIcon'
import HeaderForm from '@/components/HeaderForm/index.vue'
import DictionarySelect from '@/components/DictionarySelect/index.vue'
import BasePagination from '@/components/BasePagination/index.vue'
import AreaSelect from '@/components/AreaSelect/index.vue'
import CustomUploader from '@/components/CustomUploader/CustomUploader.vue'
import CommonSelect from '@/components/CommonSelect/index.vue'
import CustomTree from '@/components/CustomTree'
import VueAMap from 'vue-amap'
import '@/views/manage/custom-screen/components/VisualDrag/custom-component'
import '@/views/manage/custom-screen-page/components/custom-components/index'
import '@/views/electronic-display/led/components/custom-screen/components/VisualDrag/custom-component'
import './utils/momentLocale'

Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'df2215fefa338567bc810b4e10d4bfd3',
  securityCode: '61d4fa29aac309c61d8ba174d6866585',
  plugin: [
    'AMap.Geolocation', // 定位空间，用来获取和展示用户主机所在的经纬度位置
    'AMap.Autocomplete', // 输入提示插件
    'AMap.PlaceSearch', // POI搜索插件
    'AMap.Scale', // 右下角缩略图插件，比例尺
    'AMap.OverView', // 地图鹰眼插件
    'AMap.ToolBar', // 地图工具条
    'AMap.MapType', // 类别切换空间，实现默认图层与卫星图，实施交通层之间切换的控制
    'AMap.PolyEditor', // 编辑 折线多边形
    'AMap.CircleEditor',
    'AMap.Geocoder'
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
  uiVersion: '1.0.11'
})
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }
Vue.component(HeaderForm.name, HeaderForm)
Vue.component(DictionarySelect.name, DictionarySelect)
Vue.component(BasePagination.name, BasePagination)
Vue.component(AreaSelect.name, AreaSelect)
Vue.component(CustomUploader.name, CustomUploader)
Vue.component(CommonSelect.name, CommonSelect)
Vue.component(SvgIcon.name, SvgIcon)
Vue.component(CustomTree.name, CustomTree)

Vue.use(permission.install)

Element.Select.props.filterable = {
  type: Boolean,
  default: true
}
Element.Select.props.clearable = {
  type: Boolean,
  default: true
}
Element.Input.props.clearable = {
  type: Boolean,
  default: true
}

Element.DatePicker.props.pickerOptions = {
  type: Object,
  default: () => ({
    firstDayOfWeek: 1
  })
}

Vue.use(Element, {
  size: Cookies.get('size') || 'small', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: (h) => h(App)
})
